import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { CommonButton } from '@/components/ui/common-button';
import { useToast } from '@/components/ui/use-toast';

const RejectRequestDialog = ({ open, onOpenChange, submitting, onSubmit }) => {
  const [rejectionReason, setRejectionReason] = useState('');
  const { toast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (rejectionReason.trim().length < 5) {
      toast({
        title: 'Rejection Reason Required',
        description: 'Rejection reason must be at least 5 characters long.',
        variant: 'destructive',
      });
      return;
    }
    onSubmit(rejectionReason);
  };

  return (
    <Dialog open={open} onOpenChange={(val) => {
      if (!val) setRejectionReason('');
      onOpenChange(val);
    }}>
      <DialogContent className="sm:max-w-[400px]">
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle className="text-lg font-bold text-red-600">Reject Edit Request</DialogTitle>
          </DialogHeader>

          <div className="py-4 space-y-3">
            <label className="text-sm font-semibold text-foreground">Specify Reason for Rejection *</label>
            <textarea
              value={rejectionReason}
              onChange={(e) => setRejectionReason(e.target.value)}
              placeholder="e.g. Please upload supporting document..."
              className="w-full bg-background border border-border rounded-lg p-2.5 text-sm min-h-[80px] outline-none focus:border-red-500 text-foreground"
              required
            />
          </div>

          <DialogFooter className="flex justify-end gap-2">
            <CommonButton 
              type="button" 
              variant="outline" 
              onClick={() => onOpenChange(false)} 
              disabled={submitting}
              className="w-32"
            >
              Cancel
            </CommonButton>
            <CommonButton 
              type="submit" 
              variant="destructive" 
              loading={submitting}
              className="w-32"
            >
              Confirm Rejection
            </CommonButton>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default RejectRequestDialog;
